import { Box, Typography, Button, Container } from '@mui/material';
import { SentimentDissatisfied as SadIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export const LandingPageNotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'grey.50',
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: 'center',
            py: 8,
          }}
        >
          <SadIcon
            sx={{
              fontSize: 80,
              color: 'grey.400',
              mb: 3,
            }}
          />

          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              color: 'grey.900',
              mb: 2,
            }}
          >
            Page Not Found
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: 'grey.600',
              mb: 4,
              fontSize: '1.1rem',
            }}
          >
            Sorry, we couldn't find the page you're looking for. It may have been moved or doesn't exist.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="contained"
              onClick={() => navigate('/')}
              sx={{
                bgcolor: '#5D5FEF',
                textTransform: 'none',
                px: 3,
                py: 1,
                '&:hover': {
                  bgcolor: '#4B4DDB',
                },
              }}
            >
              Go to Homepage
            </Button>

            <Button
              variant="outlined"
              onClick={() => navigate('/register')}
              sx={{
                borderColor: '#5D5FEF',
                color: '#5D5FEF',
                textTransform: 'none',
                px: 3,
                py: 1,
                '&:hover': {
                  borderColor: '#4B4DDB',
                  bgcolor: '#5D5FEF08',
                },
              }}
            >
              Create Your Own Page
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
